import axiosInstance from "./axios-service/axiosInstance";

const headers = {
  Accept: "application/json;odata=nometadata",
};

const sourceService = {
  fetchAllSources: () => {
    return axiosInstance.get(
      "/itl_sourcemasters?$select=itl_sourcemasterid,itl_name,statecode&$orderby=createdon desc",
      {
        headers: headers,
      }
    );
  },

  fetchAllActiveSources: () => {
    return axiosInstance.get(
      "/itl_sourcemasters?$select=itl_sourcemasterid,itl_name,statecode&$filter=statecode eq 0&$orderby=createdon desc",
      {
        headers: headers,
      }
    );
  },

  updateSource: async (id, obj) => {
    return axiosInstance.patch(`/itl_sourcemasters(${id})`, obj, {
      headers: headers,
    });
  },

  addSource: async (obj) => {
    return axiosInstance.post("/itl_sourcemasters", obj, {
      headers: headers,
    });
  },
};

export default sourceService;
